import { Tab } from '@headlessui/react'
import { PricedProduct } from '@medusajs/medusa/dist/types/pricing'
import Back from '@modules/common/icons/back'
import FastDelivery from '@modules/common/icons/fast-delivery'
import Refresh from '@modules/common/icons/refresh'
import clsx from 'clsx'
import { useMemo } from 'react'

type ProductTabsProps = {
  product: PricedProduct
}

const ProductTabs = ({ product }: ProductTabsProps) => {
  const tabs = useMemo(() => {
    return [
      // {
      //   label: 'Product Information',
      //   component: <ProductInfoTab product={product} />,
      // },
      {
        label: 'Shipping & Returns',
        component: <ShippingInfoTab />,
      },
    ]
  }, [product])

  return (
    <div>
      <Tab.Group>
        <Tab.List className="border-b border-gray-200 box-border grid grid-cols-2">
          {tabs.map((tab, i) => {
            return (
              <Tab
                key={i}
                className={({ selected }) =>
                  clsx(
                    'text-left uppercase text-small-regular pb-2 -mb-px border-b border-gray-200 transition-color duration-150 ease-in-out',
                    {
                      'border-b border-gray-900': selected,
                    }
                  )
                }
              >
                {tab.label}
              </Tab>
            )
          })}
        </Tab.List>
        <Tab.Panels>
          {tabs.map((tab, j) => {
            return <div key={j}>{tab.component}</div>
          })}
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}

const ProductInfoTab = ({ product }: ProductTabsProps) => {
  const showMaterial = !!product.material
  const showCountry = !!product.origin_country
  const showType = !!product.type
  const showWeight = !!product.weight
  const showDimensions = !!product.length && !!product.width && !!product.height
  // const showTags = !!product.tags.length
  return (
    <Tab.Panel className="text-small-regular py-8">
      <div className="grid grid-cols-2 gap-x-8 -mt-4 mb-4">
        <div className="flex flex-col gap-y-4">
          {showMaterial && (
            <div>
              <span className="font-semibold">Material</span>
              <p>{product.material}</p>
            </div>
          )}
          {showCountry && (
            <div>
              <span className="font-semibold">Country of origin</span>
              <p>{product.origin_country}</p>
            </div>
          )}
          {showType && (
            <div>
              <span className="font-semibold">Type</span>
              <p>{product.type!.value}</p>
            </div>
          )}
          {showWeight && (
            <div>
              <span className="font-semibold">Weight</span>
              <p>{`${product.weight} g`}</p>
            </div>
          )}
          {showDimensions && (
            <div>
              <span className="font-semibold">Dimensions</span>
              <p>
                {`${product.length}L x ${product.width}W x ${product.height}H`}
              </p>
            </div>
          )}
        </div>
      </div>
      {/* {showTags && (
        <div>
          <span className="font-semibold">Tags</span>
          {product.tags.map((tag, i) => {
            return (
              <span
                key={i}
                className="inline-block bg-gray-100 text-gray-600 px-2 py-1 rounded-sm mr-2"
              >
                {tag.value}
              </span>
            )
          })}
        </div>
      )} */}
    </Tab.Panel>
  )
}

const ShippingInfoTab = () => {
  return (
    <Tab.Panel className="text-small-regular py-8">
      <div className="grid grid-cols-1 gap-y-8">
        <div className="flex items-start gap-x-2">
          <FastDelivery />
          <div>
            <span className="font-semibold">Fast delivery</span>
            <p className="max-w-sm">
              Your package will arrive in 3-5 business days at your pick up
              location or in the comfort of your home.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-x-2">
          <Refresh />
          <div>
            <span className="font-semibold">Simple exchanges</span>
            <p className="max-w-sm">
              Is the fit not quite right? No worries - we&apos;ll exchange your
              product for a new one.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-x-2">
          <Back />
          <div>
            <span className="font-semibold">Easy returns</span>
            <p className="max-w-sm">
              Just return your product and we&apos;ll refund your money. No
              questions asked – we&apos;ll do our best to make sure your return
              is hassle-free.
            </p>
          </div>
        </div>
      </div>
    </Tab.Panel>
  )
}

export default ProductTabs
